import React from "react";
import ScrollIntoView from 'react-scroll-into-view'
import "./index.css"

const Nav = React.forwardRef((props, ref) =>  {
    return (
        <nav className="navbar navbar-expand-lg navbar-light fixed-top" id="mainNav">
            <div className="container">
                <ScrollIntoView className="d-inline" selector="#home"><a className="typewriter navbar-brand js-scroll-trigger">RICH HOSEK</a></ScrollIntoView>
                <button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                    Menu
          <i className="fas fa-bars"></i>
                </button>
                <div className="collapse navbar-collapse" id="navbarResponsive">
                    <ul className="navbar-nav ml-auto">
                        <li className="nav-item">
                            <ScrollIntoView className="d-inline" selector="#latest"><a className="nav-link js-scroll-trigger">Latest</a></ScrollIntoView>
                        </li>
                        <li className="nav-item">
                            <ScrollIntoView className="d-inline" selector="#books"><a className="nav-link js-scroll-trigger">Books</a></ScrollIntoView>
                        </li>
                        <li className="nav-item">
                            <ScrollIntoView  className="d-inline" selector="#television"><a className="nav-link js-scroll-trigger">Television</a></ScrollIntoView>
                        </li>
                        <li className="nav-item">
                            <ScrollIntoView  className="d-inline" selector="#contact"><a className="nav-link js-scroll-trigger">Contact</a></ScrollIntoView>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
});

export default Nav;